
import { Component, Prop, Vue } from 'vue-property-decorator'
import CATEGORY_MAP from '~/json/catRoot.json'

@Component
export default class FilterAndSortCategories extends Vue {
  @Prop()
    selectedCategoryIds: string[]

  get selectedCategoryIdsOrAll(): string[] {
    if (this.selectedCategoryIds && this.selectedCategoryIds.length) {
      return this.selectedCategoryIds
    }
    return Object.keys(CATEGORY_MAP)
  }

  scrollToCategories() {
    this.$puScrollTo('[data-filter-categories-scroll-target]', {
      duration: 300,
      offset: 0,
    })
  }
}
